import React, { useRef, useState, useEffect } from "react"
/* import axios from "axios" */
import { Link, useNavigate } from "react-router-dom"
import { APIServerIP } from "../../../helpers/Sats_api_helper"
import moment from "moment"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

//Import Date Picker
import { format } from "date-fns"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

//Validation
import * as Yup from "yup"
import { useFormik, Field } from "formik"

// Redux
import { useSelector, useDispatch } from "react-redux"
import {
  createEvent,
  updateEvent,
  resetEvent,
} from "../../../toolkitStore/eventMSlice/eventSlice"
import { Feedback } from "@mui/icons-material"

// const formData = new FormData()

function EventForm(props) {
  //meta title
  /* document.title =
    "Create New Project | Skote - React Admin & Dashboard Template" */
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { newEventList, isSuccessfullyAdded, isUserEdit } = useSelector(
    state => state.EventReducer
  )

  const handleCkeditorIn = (event, editor) => {
    const data = editor.getData()
    validation.setFieldValue("description", data)
  }

  document.title = "Form File Upload | Skote - React Admin & Dashboard Template"

  const [image, SetImage] = useState()
  const [selectedData, SetSelectData] = useState()
  const [dis4, SetDis4] = useState(false)
  const [dis1, SetDis1] = useState(false)

  const event_id_c = JSON.parse(localStorage.getItem("event_id"))

  //edit /update Function

  // useEffect(() => {
  //   if (isSuccessfullyAdded) {
  //     navigate("/eventlist")
  //   }
  // }, [isSuccessfullyAdded])

  useEffect(() => {
    if (isUserEdit) {
      const editUser = JSON.parse(localStorage.getItem("editUser"))
      SetSelectData(editUser)

      // if (selectedData?.event_status == "4") {
      //   SetDis1(true)
      //   SetDis4(true)
      // }
      // if (selectedData?.event_status == "1") {
      //   SetDis1(true)
      // }
      // if (selectedData?.event_status == "0") {
      //   SetDis1(false)
      //   SetDis4(false)
      // }
    }
  }, [isUserEdit])
  //Cancel
  const Cancel = e => {
    e.preventDefault()
    localStorage.removeItem("editUser")
    SetSelectData("")
    navigate("/eventlist")
  }

  const generateEventTypeId = (value) => {
  switch (value) {
    case "FOOD":
      return "ET001"
    case "EVENT":
      return "ET002"
    case "EVENTWITHFOOD":
      return "ET003"
    default:
      return null
  }
}

const generateFoodTypeId = (value) => {
  switch (value) {
    case "VEG":
      return "FT001"
    case "NONVEG":
      return "FT002"
    case "BOTH":
      return "FT003"
    default:
      return null
  }
}


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: selectedData?.name || "",
      short_description: selectedData?.short_description || "",
      short_veg_dec:selectedData?.short_veg_dec||"",
      short_nonveg_dec:selectedData?.short_nonveg_dec||"",
      description: selectedData?.description || "",
      image_name: selectedData?.image_name || "",
      event_for: selectedData?.event_for || "",
      type: selectedData?.type || "",
      eventType: selectedData?.eventType || "",
        eventTypeId: selectedData?.eventTypeId || null,

      foodType: selectedData?.foodType || "",
        foodTypeId: selectedData?.foodTypeId || null,
        freeFoodOption: selectedData?.freeFoodOption || "", // NO_FOOD / WITH_FOOD
freeFoodType: selectedData?.freeFoodType || "",     // FREE_FOOD / PAID_FOOD


includeTicketType: selectedData?.includeTicketType || "", 


       image_preview: selectedData?.image_preview || 0,
      no_of_days: selectedData?.no_of_days || "",
      // start_date: selectedData?.start_date
      //   ? moment.parseZone(selectedData?.start_date).format("yyyy-MM-DDThh:mm")
      //   : "",
      start_date: selectedData?.start_date
  ? moment.utc(selectedData.start_date).local().format("YYYY-MM-DDTHH:mm")
  : "",

      active_status: selectedData?.active_status || "Active",
      publish_status: selectedData?.publish_status || "Draft",
      publish_status_id: selectedData?.public_status_id || 1,
    },
    validationSchema: Yup.object({
      name: Yup.string().required(" Enter Your Event Name"),
      short_description: Yup.string().required(" Enter Your SHORT Description"),
      start_date: Yup.string().required(
        " Enter Your Event Start Date and Time"
      ),
      event_for: Yup.string().required(" Event For is required"),
      // active_status: Yup.string().required("Active statusFor is required"),

      type: Yup.string().required("Type is required"),
      
      // image_preview: Yup.string("Image Preview is reuired"),
      image_name: Yup.string().required("A photo is required"),
      no_of_days: Yup.number().required("Number of day event"),
      
      eventType: Yup.string().when("type", {
    is: "PAID",
    then: schema => schema.required("EventType is required"),
    otherwise: schema => schema.notRequired(),
  }),

  // free event working on it 

  freeFoodOption: Yup.string().when("type", {
  is: "FREE",
  then: schema => schema.required("Food option is required"),
  otherwise: schema => schema.notRequired(),
}),

freeFoodType: Yup.string().when(
  ["type", "freeFoodOption"],
  {
    is: (type, freeFoodOption) =>
      type === "FREE" && freeFoodOption === "WITH_FOOD",
    then: schema => schema.required("Food payment type is required"),
    otherwise: schema => schema.notRequired(),
  }
),

foodType: Yup.string().when(
  ["type", "freeFoodType"],
  {
    is: (type, freeFoodType) =>
      type === "FREE" && freeFoodType === "PAID_FOOD",
    then: schema => schema.required("Food type is required"),
    otherwise: schema => schema.notRequired(),
  }
),

includeTicketType: Yup.string().when(
  ["type", "freeFoodType"],
  {
    is: (type, freeFoodType) =>
      type === "FREE" && freeFoodType === "PAID_FOOD",
    then: schema => schema.required("Ticket option is required"),
    otherwise: schema => schema.notRequired(),
  }
),



//   foodType: Yup.string().when("eventType", {
//   is: val => val === "FOOD" || val === "EVENTWITHFOOD",
//   then: schema => schema.required("Food Type is required"),
//   otherwise: schema => schema.notRequired(),
// }),

eventTypeId: Yup.string().when("type", {
  is: "PAID",
  then: (schema) => schema.required("Event type is required"),
  otherwise: (schema) => schema.nullable(),
}),

foodTypeId: Yup.string().when("eventTypeId", {
  is: (val) => val === "ET001" || val === "ET003", // only food or event-with-food
  then: (schema) => schema.required("Food type is required"),
  otherwise: (schema) => schema.nullable(),
}),




    }),
//     onSubmit: (values, actions) => {
//       console.log("hi"+values.type )
//   //     if (values.type === "FREE") {
//   //   values.eventType = ""
//   //    values.eventTypeId = null
//   //   values.foodType = ""
//   //   values.foodTypeId = null
//   // }

//   //  free event changes ---
//   if (values.type === "FREE") {
//   values.eventType = ""
//   values.eventTypeId = null

//   // Only clear foodType if NOT PAID_FOOD
//   if (values.freeFoodType !== "PAID_FOOD") {
//     values.foodType = ""
//     values.foodTypeId = null
//   }
// }

//       if (selectedData?._id) {
//         // image == undefined
//         //   ? (values["imageUpdated"] = false)
//         //   : (values["imageUpdated"] = true)
//         values["_id"] = selectedData?._id
//         console.log("mm", values)
//         dispatch(updateEvent(image, values))
//       } else {
//         dispatch(createEvent(image, values))
//       }

//       actions.resetForm()
//       SetImage("")
//       navigate("/eventlist")
//       console.log(values)
//     },

onSubmit: (values, actions) => {

  const payload = {
    ...values,
    start_date: moment(values.start_date).utc().toISOString(),
  }

  if (values.type === "FREE") {
    payload.eventType = ""
    payload.eventTypeId = null

    if (values.freeFoodType !== "PAID_FOOD") {
      payload.foodType = ""
      payload.foodTypeId = null
    }
  }

  if (selectedData?._id) {
    payload._id = selectedData._id
    dispatch(updateEvent(image, payload))
  } else {
    dispatch(createEvent(image, payload))
  }

  actions.resetForm()
  SetImage("")
  navigate("/eventlist")
}

  })
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem="Event Information" />
          <Row>
            <Form
              onSubmit={event => {
                event.preventDefault()
                validation.handleSubmit()
              }}
            >
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center border-bottom border-secondary pb-3">
                    <h5 className="mb-1 card-title flex-grow-1 text-primary ">
                      {event_id_c ? event_id_c.EventName : "New Event"}
                    </h5>
                    <div className="mb-1 flex-shrink-0">
                      <Link to="/eventlist" className="btn btn-secondary me-1">
                        Back
                      </Link>
                      <Link
                        to="#!"
                        onClick={() => {
                          /*  dispatch(fetchServices(userInformation.m_company_id)) */
                        }}
                        className="btn btn-light me-1"
                      >
                        <i className="mdi mdi-refresh"></i>
                      </Link>
                    </div>
                  </div>

                  <Row className="mt-3 mb-3">
                    <Col lg={12} className="mb-3">
                      <div className="">
                        <Label htmlFor="name">Event Name</Label>
                        <Input
                          name="name"
                          className={`form-control`}
                          placeholder="Enter Event Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                          disabled={dis4}
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={12} className="mb-3">
                      <div className="">
                        <Label htmlFor="short_description">
                          Event Short Description
                        </Label>
                        <Input
                          name="short_description"
                          className={`form-control`}
                          placeholder="Enter event short description"
                          type="textarea"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.short_description || ""}
                          invalid={
                            validation.touched.short_description &&
                            validation.errors.short_description
                              ? true
                              : false
                          }
                          disabled={dis4}
                        />
                        {validation.touched.short_description &&
                        validation.errors.short_description ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.short_description}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12} className="mb-3">
                      <div
                        className="" //position-relative
                      >
                        <Label htmlFor="how_to">Description</Label>
                        <CKEditor
                          config={{
                            placeholder: "Write about event...",
                          }}
                          editor={ClassicEditor}
                          // data={validation.values.event_desc}
                           data={validation.values.description} 
                          onChange={handleCkeditorIn}
                          disabled={dis4}
                        />
                      </div>
                    </Col>
                    <Col lg={6} className="">
                      <div className="">
                        <Label htmlFor="image_preview">Image Preview</Label>
                        <select
                          id="image_preview"
                          name="image_preview"
                          className={`form-select ${
                            validation.touched.image_preview &&
                            validation.errors.image_preview &&
                            "is-invalid"
                          }`}
                          value={validation.values.image_preview}
                          onChange={e =>
                            validation.setFieldValue(
                              "image_preview",
                              e.target.value
                            )
                          }
                        >
                          <option value={0}>Landscape</option>
                          <option value={1}>Protriat</option>
                        </select>
                        {validation.touched.image_preview &&
                        validation.errors.image_preview ? (
                          <FormFeedback>
                            {validation.errors.image_preview}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={6} className="">
                      <div className="">
                        <Label htmlFor="image_name">Event Photos</Label>
                        <Input
                          name="image_name"
                          className="form-control"
                          placeholder="Enter The Designation"
                          type="file"
                          onChange={e => {
                            validation.setFieldValue(
                              "image_name",
                              e.currentTarget.files[0].name
                            )
                            SetImage(e.currentTarget.files[0])
                          }}
                          invalid={
                            validation.touched.image_name &&
                            validation.errors.image_name
                              ? true
                              : false
                          }
                          disabled={dis1}
                        />
                        {validation.touched.image_name &&
                        validation.errors.image_name ? (
                          <div
                            type="invalid"
                            className="invalid-feedback"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.image_name}
                          </div>
                        ) : selectedData?.image_name ? (
                          <a
                            href={`${APIServerIP}uploads/${selectedData?.image_name}`}
                          >
                            {selectedData?.image_name}
                          </a>
                        ) : (
                          validation.values.image_name
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <div className="">
                        <Label htmlFor="type">Event Type</Label>
                          <select
                            id="type"
                            name="type"
                            className={`form-select ${
                              validation.touched.type && validation.errors.type && "is-invalid"
                            }`}
                            onChange={e => {
                              const selectedType = e.target.value
                              validation.setFieldValue("type", selectedType)

                               if (selectedType === "FREE") {
            validation.setFieldValue("eventType", "")
            validation.setFieldValue("eventTypeId", null)
            validation.setFieldValue("foodType", "")
            validation.setFieldValue("foodTypeId", null)
          }
                            }}
                            value={validation.values.type || ""}
                          >
                          <option value=" ">Select Type </option>
                          <option value={"PAID"}>PAID</option>
                          <option value={"FREE"}>FREE</option>
                        </select>
                        {validation.touched.type && validation.errors.type ? (
                          <FormFeedback>{validation.errors.type}</FormFeedback>
                        ) : null}
                      </div> 
                    </Col>
                    {/*free event food   */}

                    {validation.values.type === "FREE" && (
                       <Row className="mt-3">
  <Col lg={3}>
    <Label>Include Food</Label>
    <select
      className="form-select"
      value={validation.values.freeFoodOption}
      onChange={(e) => {
        const val = e.target.value
        validation.setFieldValue("freeFoodOption", val)

        // Reset all food-related fields
        validation.setFieldValue("freeFoodType", "")
        validation.setFieldValue("foodType", "")
        validation.setFieldValue("foodTypeId", null)
      }}
    >
      <option value="">Select</option>
      
      <option value="WITH_FOOD">With Food</option>
      <option value="NO_FOOD">Without Food</option>
    </select>
  </Col>


{/* {validation.values.type === "FREE" && */}
 {validation.values.freeFoodOption === "WITH_FOOD" && (
  <Col lg={3}>
    <Label>Free/Paid</Label>
    <select
      className="form-select"
      value={validation.values.freeFoodType}
      onChange={(e) => {
        const val = e.target.value
        validation.setFieldValue("freeFoodType", val)
          validation.setFieldValue("includeTicketType", "")


        if (val !== "PAID_FOOD") {
          validation.setFieldValue("foodType", "")
          validation.setFieldValue("foodTypeId", null)
        }
      }}
    >
      <option value="">Select</option>
      <option value="FREE_FOOD">Free</option>
      <option value="PAID_FOOD">Paid</option>
    </select>
  </Col>
)}



{/* {validation.values.type === "FREE" && */}
 {validation.values.freeFoodType === "PAID_FOOD" && (
  <Col lg={3}>
    <Label>Food Type</Label>
    <select
      className="form-select"
      value={validation.values.foodType}
      onChange={(e) => {
        const value = e.target.value
        validation.setFieldValue("foodType", value)
        validation.setFieldValue("foodTypeId", generateFoodTypeId(value))

         validation.setFieldValue("short_veg_dec", "")
  validation.setFieldValue("short_nonveg_dec", "")

      }}
    >
      <option value="">Select Food Type</option>
      <option value="VEG">Only Veg</option>
      <option value="NONVEG">Only Non-Veg</option>
      <option value="BOTH">Veg & Non-Veg</option>
      
    </select>
  </Col>
)}

{/* {validation.values.type === "FREE" && */}
 {validation.values.freeFoodType === "PAID_FOOD" && (

  <Col lg={3}>
    <Label>Ticket Option</Label>
    <select
      className={`form-select ${
        validation.touched.includeTicketType &&
        validation.errors.includeTicketType
          ? "is-invalid"
          : ""
      }`}
      value={validation.values.includeTicketType}
      onChange={(e) =>
        validation.setFieldValue("includeTicketType", e.target.value)
      }
    >
      <option value="">Select</option>
      <option value="NONE">None</option>
      <option value="ADULT_CHILD">Adult + Child</option>
       
    </select>

    {validation.touched.includeTicketType &&
     validation.errors.includeTicketType && (
      <FormFeedback>
        {validation.errors.includeTicketType}
      </FormFeedback>
    )}
  </Col>
 )}
 </Row>
)}




                    {/* end of free food */}

                      {validation.values.type === "PAID" && (<Col>
                      <div className="">
                        <Label htmlFor="type">Food/Event</Label>
                        <select
                          id="eventType"
                          name="eventType"
                          className={`form-select ${
                            validation.touched.eventType &&
                            validation.errors.eventType &&
                            "is-invalid"
                          }`}
                          // onChange={e =>
                          //   validation.setFieldValue("eventType", e.target.value)
                          // }
  //                          onChange={(e) => {
  //   const value = e.target.value
  //   validation.setFieldValue("eventType", value)
  //   validation.setFieldValue("eventTypeId", generateEventTypeId(value))

  //   // Reset food type when event type doesn't need food
  //   if (value !== "ET001" && value !== "ET003") {
  //     validation.setFieldValue("foodType", "")
  //     validation.setFieldValue("foodTypeId", null)
  //   }
  // }}
  onChange={(e) => {
  const value = e.target.value
  const eventTypeId = generateEventTypeId(value)

  validation.setFieldValue("eventType", value)
  validation.setFieldValue("eventTypeId", eventTypeId)

  if (eventTypeId !== "ET001" && eventTypeId !== "ET003") {
    validation.setFieldValue("foodType", "")
    validation.setFieldValue("foodTypeId", null)
  }
}}

                          value={validation.values.eventType || ""}
                        >
                          <option value=" ">Select Type </option>
                          <option value={"FOOD"}>Only Food</option>
                          <option value={"EVENT"}>Only Event</option>
                          <option value={"EVENTWITHFOOD"}>Event with Food</option>
                        </select>
                        {validation.touched.eventType && validation.errors.eventType ? (
                          <FormFeedback>{validation.errors.eventType}</FormFeedback>
                        ) : null}
                        {/* {validation.values.eventType === "EVENT" && (
  <div className="mt-2">
    <div className="form-check">
      <input
        type="checkbox"
        id="includeFood"
        name="includeFood"
        className="form-check-input"
        onChange={e => validation.setFieldValue("includeFood", e.target.checked)}
        // checked={validation.values.includeFood || false}
      />
      <Label className="form-check-label" htmlFor="includeFood">
        Include Food
      </Label>
    </div>
  </div>
)} */}
                      </div>
                    </Col>)}

                    {(validation.values.eventTypeId === "ET001" ||
  validation.values.eventTypeId === "ET003") && (
  <Col lg={3} md={4} sm={6} className="mb-3">
    <div className="">
      <Label htmlFor="foodType">Food Type</Label>
      <select
        id="foodType"
        name="foodType"
        className={`form-select ${
          validation.touched.foodType && validation.errors.foodType
            ? "is-invalid"
            : ""
        }`}
        // onChange={validation.handleChange}
        onChange={(e) => {
    const value = e.target.value
    validation.setFieldValue("foodType", value)
    validation.setFieldValue("foodTypeId", generateFoodTypeId(value))

     validation.setFieldValue("short_veg_dec", "")
  validation.setFieldValue("short_nonveg_dec", "")

  }}
        onBlur={validation.handleBlur}
        value={validation.values.foodType || ""}
      >
        <option value="">Select Food Type</option>
        <option value="VEG">Only Veg</option>
        <option value="NONVEG">Only Non-Veg</option>
        <option value="BOTH">Both Veg & Non-Veg</option>
      </select>
      {validation.touched.foodType && validation.errors.foodType ? (
        <FormFeedback>{validation.errors.foodType}</FormFeedback>
      ) : null}
    </div>
  </Col>
)}

                    <Col>
                      <div className="">
                        <Label htmlFor="event_for">Event For</Label>
                        <select
                          id="event_for"
                          name="event_for"
                          // className="form-select"
                          className={`form-select ${
                            validation.touched.event_for &&
                            validation.errors.event_for &&
                            "is-invalid"
                          }`}
                          value={validation.values.event_for || ""}
                          onChange={e =>
                            validation.setFieldValue(
                              "event_for",
                              e.target.value
                            )
                          }
                        >
                          <option value={""}>Select Event for</option>
                          <option value={"All"}>All</option>
                          <option value={"Member"}>Member</option>
                          <option value={"Non-Member"}>Non-Member</option>
                        </select>
                        {validation.touched.event_for &&
                        validation.errors.event_for ? (
                          <FormFeedback>
                            {validation.errors.event_for}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col>
                      <div className="">
                        <Label htmlFor="no_of_days">Number of days</Label>
                        <Input
                          name="no_of_days"
                          className={`form-control`}
                          placeholder="Number of days"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.no_of_days || ""}
                          invalid={
                            validation.touched.no_of_days &&
                            validation.errors.no_of_days
                              ? true
                              : false
                          }
                          disabled={dis4}
                        />
                        {validation.touched.no_of_days &&
                        validation.errors.no_of_days ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.no_of_days}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col>
                      <div className="">
                        <Label htmlFor="start_date">Start Date & Time</Label>
                        <Input
                          name="start_date"
                          className="form-control  "
                          placeholder="yyyy-mm-dd"
                          type="datetime-local"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.start_date || ""}
                          invalid={
                            validation.touched.start_date &&
                            validation.errors.start_date
                              ? true
                              : false
                          }
                          disabled={dis1}
                        />
                        {validation.touched.start_date &&
                        validation.errors.start_date ? (
                          <FormFeedback type="invalid">
                            {validation.errors.start_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    {event_id_c && (
                      <Col>
                        <div className="">
                          <Label htmlFor="active_status"> Event Status </Label>
                          <select
                            id="active_status"
                            name="active_status"
                            className={`form-select ${
                              validation.touched.active_status &&
                              validation.errors.active_status &&
                              "is-invalid"
                            }`}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.active_status}
                          >
                            <option value={" "}>Select the status</option>
                            <option value={"Active"}>Active</option>
                            <option value={"Inactive"}>Inactive</option>
                          </select>
                          {validation.touched.active_status &&
                          validation.errors.active_status ? (
                            <FormFeedback>
                              {validation.errors.active_status}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    )}
                  </Row>
                  {/* food text to display in web static */}
 
 <Row>
  {/* Veg Description */}
  {(validation.values.foodType === "VEG" ||
    validation.values.foodType === "BOTH") && (
    <Col lg={6} md={6} sm={12} className="mb-3">
      <Label htmlFor="short_veg_dec">Event Veg Desc</Label>
      <Input
        name="short_veg_dec"
        className="form-control"
        placeholder="Entry + Dinner + Festive Goody"
        type="textarea"
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        value={validation.values.short_veg_dec || ""}
      />
    </Col>
  )}

  {/* Non-Veg Description */}
  {(validation.values.foodType === "NONVEG" ||
    validation.values.foodType === "BOTH") && (
    <Col lg={6} md={6} sm={12} className="mb-3">
      <Label htmlFor="short_nonveg_dec">Event Non-Veg Desc</Label>
      <Input
        name="short_nonveg_dec"
        className="form-control"
        placeholder="Entry + Dinner + Festive Goody"
        type="textarea"
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        value={validation.values.short_nonveg_dec || ""}
      />
    </Col>
  )}
</Row>



                  <Col className="d-flex mt-3 justify-content-end">
                    <div className=" text-center mt-3 ">
                      <button
                        type="submit"
                        className="btn btn-success w-md px-5"
                      >
                        {selectedData?._id ? "Update" : "Submit"}
                      </button>
                    </div>
                    <div className=" text-center mt-3 mx-3 ">
                      <button
                        onClick={Cancel}
                        className="btn btn-danger w-md px-5"
                      >
                        {"Cancel"}
                      </button>
                    </div>
                  </Col>
                </CardBody>
              </Card>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EventForm
